// T-178 (2) (v1.8.55, Session 43): Statusauswahl im Dialog "Buchung bearbeiten". Die Liste kannte Angebotsstatus wie
// "Angebot versendet" (OfferSent) nicht, der Browser zeigte dann die erste Option "Entwurf" an (gespeichert wurde ohne Eingriff
// weiter der alte Status). Der aktuelle Status wird deshalb ergänzt, wenn er fehlt. Reine Funktion, getestet in statusAuswahl.test.ts.

export interface StatusOption {
  value: string;
  label: string;
}

const WEITERE_STATUS: Record<string, string> = {
  OfferSent: 'Angebot versendet',
  OfferAccepted: 'Angebot angenommen',
  OfferDeclined: 'Angebot abgelehnt',
  OfferExpired: 'Angebot abgelaufen',
  PendingApproval: 'Anfrage in Prüfung',
  NoShow: 'Nicht erschienen',
  Paid: 'Bezahlt',
};

/** Bezeichnung eines Status außerhalb der Standardliste (unbekannte Codes unverändert). */
export function statusBezeichnung(code: string): string {
  const treffer = Object.keys(WEITERE_STATUS).find(k => k.toLowerCase() === code.toLowerCase());
  return treffer ? WEITERE_STATUS[treffer] : code;
}

/**
 * Standardliste plus aktueller Status, wenn er darin fehlt (vorne, damit die Anzeige stimmt).
 * Vergleich ohne Groß- und Kleinschreibung wie beim Übernehmen des Status in den Dialog.
 */
export function statusOptionenMitAktuellem(optionen: StatusOption[], aktuell?: string | null): StatusOption[] {
  const code = (aktuell ?? '').trim();
  if (!code || optionen.some(o => o.value.toLowerCase() === code.toLowerCase())) return optionen;
  return [{ value: code, label: statusBezeichnung(code) }, ...optionen];
}
